import { lightTheme } from 'amazon-chime-sdk-component-library-react'

export const light = {
    ...lightTheme.controlBar,
    bgd: 'transparent',
    shadow: 'none'
}
